import axios from "axios";
import {useQueryClient} from "react-query";
import {useMutationWithAuthentication} from "../../index";
import {addAuthToFetchOpts} from "../../../config/queryopts";
import {apiUrl} from "../../../config/api";


export const UpdateGroupBlockListPolicyIPFetcher = (accessToken, {groupId, params}) => {
  return axios.put(`${apiUrl}/operations/board-groups/${groupId}/blocked-lists/policy/ip`, params, addAuthToFetchOpts(accessToken, {})).then(res => res.data);
}


export const useUpdateGroupBlockListPolicyIPMutation = (fetcher = UpdateGroupBlockListPolicyIPFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['update-operation-group-blocklist-policy-ip'],
    (accessToken, params) => fetcher(accessToken, params),
    {onSuccess: () => queryClient.invalidateQueries('update-operation-group-blocklist-policy-ip')}
  )
}
